import { render, staticRenderFns } from "./Page404.vue?vue&type=template&id=1a6509e4&"
import script from "./Page404.vue?vue&type=script&lang=js&"
export * from "./Page404.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/lifecheq/htdocs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a6509e4')) {
      api.createRecord('1a6509e4', component.options)
    } else {
      api.reload('1a6509e4', component.options)
    }
    module.hot.accept("./Page404.vue?vue&type=template&id=1a6509e4&", function () {
      api.rerender('1a6509e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/Errors/Page404.vue"
export default component.exports